<template>
  <div>
    <Slider></Slider>
    <div class="informativo">
      <div class="ui stackable four column grid container">
        <div class="computer only column"></div>
        <div class="column destaque">
          <div class="ui item" >
            <div class="content">
              <h2 class="header" v-text="tratamento[1].titulo"></h2>
              <div class="description">
                <p v-html="$options.filters.truncate(tratamento[1].conteudo,150)">
                </p>
              </div>
              <div class="extra">
                    <router-link class="ui right floated basic inverted mini button" :to="{ name: 'tratamento', params: { id: tratamento[1]._id} }" >Saiba mais</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="ui item">
            <div class="content">
               <h2 class="header" v-text="tratamento[2].titulo"></h2>
              <div class="description">
                <p v-html="$options.filters.truncate(tratamento[2].conteudo,150)">
                </p>
              </div>
                 <div class="extra">
                    <router-link class="ui right floated basic grey mini button" :to="{ name: 'tratamento', params: { id: tratamento[2]._id} }" >Saiba mais</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="column destaque">
          <div class="ui item">
            <div class="content">
              <h2 class="header" v-text="tratamento[4].titulo"></h2>
              <div class="description">
                <p v-html="$options.filters.truncate(tratamento[4].conteudo,150)">
                </p>
              </div>
                <div class="extra">
                    <router-link class="ui right floated basic inverted mini button" :to="{ name: 'tratamento', params: { id: tratamento[4]._id} }" >Saiba mais</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Tab></Tab>
    <NewsLatter></NewsLatter>
  </div>
</template>

<script>
import Slider from "../components/Slider.vue";
import NewsLatter from "../components/NewsLatter.vue";
import Tab from "../components/Tab.vue";
import Agendamento from "../components/Agendamento.vue";
import {json} from '../assets/json.js'
export default {
  components: {
    Slider,
    Agendamento,
    NewsLatter,
    Tab
  },
  data() { return {
    tratamento: json
  }}
};
</script>

<style lang="sass" scoped>

.informativo
    padding: 0 !important
    margin: 0 !important
    background: #f9fdfc
    position: relative !important
    .grid
        div.column
            padding: 3rem 1rem !important
            min-height: 240px !important
            display: flex !important
            .item
                padding: 0 !important
                margin: auto 0 !important
    .column
        display: flex !important
        clear: both !important
        &.computer
            &:after
                content: ''
                background: red !important
                height: 100%
                position: absolute
                background: url("../assets/images/informativo.png") !important
                background-repeat: no-repeat !important
                background-position: 100% !important
                bottom: 0 !important
                left: 0
                width: 100%
        &:nth-child(2)
            background: url("../assets/images/Limpeza.png"), #00c07f
            background-position: 50% 50%
        &:nth-child(3)
            background: url("../assets/images/aparelho.png")
            background-position: 50% 50%
        &:nth-child(4)
            background: url("../assets/images/senhor.png")
            background-position: 50% 50%

        .item
            margin: auto 0 !important
        .button
            border-radius: 25px !important
            font-size: 0.7rem !important
            opacity: 0.6
            &:hover
                opacity: 1
    .header
        font-weight: 600
        position: relative
        color: #64bfa2
        position: relative !important
        font-size: 1.2rem
        &:before
            top: 0.8rem !important
            position: absolute
            height: 5px
            width: 40%
            padding-top: 1rem !important
            content: '' !important
            border-bottom: 1px solid rgba(255,255,255,0.3) !important
    p
        color: #39565f
        font-size: 0.85rem
        margin-bottom: 1rem !important
    .destaque
        p
            color:rgba(255,255,255,0.9) !important
        .header
            color: #fff
        color: #fff
        background-color: #2a8567 !important
        p
</style>
